module.exports = __webpack_public_path__ + "static/anther-gin-7289b7f7dfa15c3cdf6715e8f4ef50e8.jpg";